// 基础信息配置
const {
	config
} = require('../config.js');
import {
	getParam,
	getParamByKeysFromCache
} from './api-utils/api-params.js';
import requestUtil from './request-utils.js'
// import { Message } from 'element-ui';
/**
 * 设置图片url
 * @param {String} imgurl
 */
function setImg(imgurl) {
	imgurl = imgurl && imgurl.indexOf("&amp;") >= 0 ? imgurl.replaceAll("&amp;", "&") : imgurl
	if (imgurl == "" || imgurl == null) {
		return config.headUrl + "/Images/MobileUse/default.png";
	} else if (imgurl.indexOf('http') >= 0) {
		return imgurl;
	} else {
		return config.headUrl + imgurl;
	}
}

/**
 * 设置图片url(400*400)
 * @param {String} imgurl
 */
function set400Img(imgurl) {
	imgurl = imgurl && imgurl.indexOf("&amp;") >= 0 ? imgurl.replaceAll("&amp;", "&") : imgurl
	if (imgurl == "" || imgurl == null) {
		return config.headUrl + "/Images/MobileUse/default.png";
	}

	// OSS图片需要缩略处理
	if (imgurl.indexOf('jkyun--jmall.oss-cn-hangzhou.aliyuncs.com') >= 0 && imgurl.indexOf("x-oss-process") < 0 && imgurl.indexOf(".svg") < 0) {
		return imgurl + "?x-oss-process=image/resize,m_lfit,h_400,w_400/quality,q_80";
	}

	if (imgurl.indexOf('http') >= 0) {
		return imgurl;
	}

	if (imgurl.indexOf("_th800.") >= 0) {
		return config.headUrl + imgurl.replace('_th800', '_th.');
	}

	// 其他结果返回
	return config.headUrl + imgurl;
}

/**
 * 默认图片
 */
function getDefaultImg() {
	return config.headUrl + "/Images/MobileUse/default.png";
}

/**
 * 设置图片url(800*800)
 * @param {String} imgurl
 */
function set800Img(imgurl) {
	if (imgurl == "" || imgurl == null) {
		return config.headUrl + "/Images/MobileUse/default.png";
	}

	// OSS图片需要缩略处理
	if (imgurl.indexOf('jkyun--jmall.oss-cn-hangzhou.aliyuncs.com') >= 0 && imgurl.indexOf("x-oss-process") < 0 && imgurl.indexOf(".svg") < 0) {
		return imgurl + "?x-oss-process=image/resize,m_lfit,h_400,w_400/quality,q_80";
	}

	if (imgurl.indexOf('http') >= 0) {
		return imgurl;
	}

	if (imgurl.indexOf("_th.") >= 0) {
		return config.headUrl + imgurl.replace('_th.', '_th800.');
	}

	// 其他结果返回
	return config.headUrl + imgurl;
}

/**
 * 固定金额显示位数
 * @param {Object} amount
 *  @param {Object} count
 */
function amountFixed(amount, count) {
	try {
		let type = typeof(amount);
		if (type == "number") {
			return amount.toFixed(count);
		} else if (type == "string") {
			return parseFloat(amount).toFixed(count);
		}
	} catch (e) {}
	return '0.00';
}

/**
 * 小数格式处理
 */
function filterTrailingZeros(number) {
	if (number != '0' && !number) {
		return '--'
	}

	let decimalKeepPlaces = localStorage.getItem('decimalKeepPlaces') || 2

	return Number(parseFloat(number || 0).toFixed(decimalKeepPlaces)).toString();
}

/** 
 * 时间数字转化 02
 * number: 数字
 */
function formatNumber(n) {
	n = n.toString();
	return n[1] ? n : '0' + n;
}

/** 
 * 时间戳转化为年 月 日 时 分 秒 
 * number: 传入时间戳 
 * format：返回格式，支持自定义，但参数必须与formateArr里保持一致 
 */
function formatTime(timestamp, format) {
	var formateArr = ['Y', 'M', 'D', 'h', 'm', 's'];
	var returnArr = [];
	if (timestamp.length == 10) {
		timestamp = timestamp * 1000;
	}
	var date = new Date(timestamp);
	returnArr.push(date.getFullYear());
	returnArr.push(formatNumber(date.getMonth() + 1));
	returnArr.push(formatNumber(date.getDate()));
	returnArr.push(formatNumber(date.getHours()));
	returnArr.push(formatNumber(date.getMinutes()));
	returnArr.push(formatNumber(date.getSeconds()));
	for (var i in returnArr) {
		format = format.replace(formateArr[i], returnArr[i]);
	}
	return format;
}

/**数组根据数组对象中的某个属性值进行排序的方法 
 * 使用例子：newArray.sort(sortBy('number',false)) //表示根据number属性降序排列;若第二个参数不传递，默认表示升序排序
 * @param attr 排序的属性 如number属性
 * @param rev true表示升序排列，false降序排序
 * */
function sortBy(attr, rev) {

	//第二个参数没有传递 默认升序排列
	if (rev == undefined) {
		rev = 1;
	} else {
		rev = (rev) ? 1 : -1;
	}

	return function(a, b) {
		a = a[attr];
		b = b[attr];
		if (a < b) {
			return rev * -1;
		}
		if (a > b) {
			return rev * 1;
		}
		return 0;
	}
}

/**
 * 加密手机号
 * @param {String} tel
 */
function regTel(tel) {
	if (tel == "" || tel == null) {
		return "";
	} else {
		return tel.replace(tel.substring(tel.length - 8, tel.length - 4), '****');
	}
}

/**
 * 检测手机号格式
 * @param {String} tel
 */
function checkTel(tel) {
	if (tel && /^[\d+]+$/.test(tel)) {
		return true;
	}
	return false;
}

/**
 * 分组
 * @param {Object} array
 * @param {Object} name
 */
function groupBy(array, name) {
	let groups = {};
	array.forEach(function(o) {
		let group = JSON.stringify(o[name]);
		groups[group] = groups[group] || [];
		groups[group].push(o);

	});
	return groups;
}

/**
 * 从缓存获取会员ID
 */
function getCustomerId() {
	return localStorage.getItem("pc_customerId") || "0";
}

/**
 * html编码
 * @param {any} str
 */
function htmlEncode(str) {
	if (typeof str != "string") return str;
	if (str.length == 0) return "";
	str = str.replace(/&/g, "&amp;");
	str = str.replace(/</g, "&lt;");
	str = str.replace(/>/g, "&gt;");
	//str = str.replace(/ /g, "&nbsp;");
	// str = str.replace(/\'/g, "&#39;");
	// str = str.replace(/\"/g, "&quot;");
	//str = str.replace(/\n/g, "<br/>");
	return str;
}

/**
 * html解码
 * @param {any} str
 */
function htmlDecode(str) {
	if (typeof str != "string") return str;
	if (str.length == 0) return "";
	str = str.replace(/&amp;/g, "&");
	str = str.replace(/&lt;/g, "<");
	str = str.replace(/&gt;/g, ">");
	str = str.replace(/img/g, "img style='width: 1200px !important;height: auto !important'")
	//str = str.replace(/&nbsp;/g, " ");
	// str = str.replace(/&#39;/g, "\'");
	// str = str.replace(/&quot;/g, "\"");
	//str = str.replace(/<br\/>/g, "\n");
	return str;
}


/**
 * html解码
 * @param {any} str
 */
function ueStrDecode(str) {
	let reg = RegExp(/&(amp;)+/g);
	return str ? htmlDecode(str.replaceAll("☚☚☚", "<").replaceAll("☛☛☛", ">").replaceAll("✪", "&amp;quot;").replaceAll("☮", "+").replaceAll("☸☸☸", "javascript:alert").replaceAll(reg, '&amp;')) : str;
}


/**
 * html解码
 * @param {any} str
 */
function htmlDecodeForMiddleRichText(str) {
	if (typeof str != "string") return str;
	if (str.length == 0) return "";
	str = str.replace(/&amp;/g, "&");
	str = str.replace(/&lt;/g, "<");
	str = str.replace(/&gt;/g, ">");
	str = str.replace(/img/g, "img style='width: 1200px !important'")
	//str = str.replace(/&nbsp;/g, " ");
	// str = str.replace(/&#39;/g, "\'");
	// str = str.replace(/&quot;/g, "\"");
	//str = str.replace(/<br\/>/g, "\n");
	return str;
}

/**
 * 获取时间戳
 * @param {Object} str
 */
function convertTime(str) {
	return new Date(str).getTime();
}
/**
 * 
 * @param {*} str 
 * @param {*} fullDate 
 */
function stringToDate(str, fullDate = true) {
	if (!str) {
		return "";
	}
	if (!isNaN(str)) {
		return str;
	}
	try {
		let date = new Date(str);
		if (!date.getTime()) {
			return str;
		}

		let year = date.getFullYear();
		let month = formatNumber(date.getMonth() + 1);
		let day = formatNumber(date.getDate());
		let hours = formatNumber(date.getHours());
		let minutes = formatNumber(date.getMinutes());
		let seconds = formatNumber(date.getSeconds());
		return fullDate ? `${year}-${month}-${day} ${hours}:${minutes}:${seconds}` : `${year}-${month}-${day}`;
	} catch (e) {
		return str;
	}
}

/**
 * 防抖
 */
function debounce(func, wait = 800, immediate = true) {
	let timer;
	return function() {
		let context = this;
		let args = arguments;
		if (timer) clearTimeout(timer);
		if (immediate) {
			var callNow = !timer;
			timer = setTimeout(() => {
				timer = null;
			}, wait);
			if (callNow) func.apply(context, args);
		} else {
			timer = setTimeout(function() {
				func.apply(context, args);
			}, wait);
		}
	}
}

/**
 * 节流
 */
function throttle(func, wait = 800) {
	let timeout = null;
	return function(...args) {
		const context2 = this;
		if (!timeout) {
			func.apply(context2, args);
			timeout = setTimeout(() => {
				timeout = null;
			}, wait);
			return false
		} else {
			return true
		}
	};
}


/**
 * 可以控制提示的节流
 */
function throttleWithAlert(func, wait = 800, context, throttleId, tip) {
	context[throttleId] = context[throttleId] || throttle(func, wait);
	if (context[throttleId]()) {
		context.$message.error(tip)
		// Message.error(tip)
	}
}


/**
 * 数组求和
 * @param {*} arr 
 * @param {*} key 
 */
function sumArr(arr, key) {
	if (!(arr && arr.length > 0)) {
		return 0;
	}

	let total = 0;
	arr.forEach(t => {
		try {
			if (key) {
				total += parseFloat(t[key]);
			} else {
				total += parseFloat(t);
			}
		} catch (e) {}
	});

	return total;
}

/*
 * 下划线转换驼峰
 */
function underlineToHump(str) {
	// 如果首字母是_，执行 replace 时会多一个_，这里需要去掉
	if (str.slice(0, 1) === '_') {
		str = str.slice(1);
	}
	return str.replace(/([^_])(?:_+([^_]))/g, function($0, $1, $2) {
		return $1 + $2.toUpperCase();
	});
}

/**
 * 检测数据是否存在 
 */
function isNullOrEmpty(val) {
	return !val || ['{}', 'null', '""', '[]'].includes(JSON.stringify(val));
}

/**
 * 保留小数位数
 */
function floatKeepDigit(num, digit = 2) {
	try {
		return parseFloat(parseFloat(num).toFixed(digit));
	} catch (e) {
		return num;
	}
}

/**
 * 数组去重
 * @param {*} arr 
 * @param {*} key 
 */
function distinctArr(arr, key) {
	if (!arr || arr.length <= 0) {
		return [];
	}
	if (key) {
		return Array.from(new Map(arr.map(item => [item[key], item])).values());;
	} else {
		return [...new Set(arr)];
	}
}

/**
 * 分批调用
 * @param {*} configList 
 */
const getAllNeedInfoByConfigList = (configList, fun) => {
	// 请求集合
	return new Promise(async (resolve, reject) => {
		let promiseList = _getPromiseListBySliceConfigList(configList, fun);

		// 等待所有接口执行完成
		Promise.all(promiseList).then((values) => {
			// values:[[promise1接口返回数据]，[promise2接口返回数据]...] 需要拍平返回
			resolve(values.flat(1));
		});
	});
}

/**
 * 生成分批调用需要的PromiseList
 * @param {*} configList 
 */
const _getPromiseListBySliceConfigList = (configList, fun, sliceCount = 30) => {
	let promiseList = []
	for (let i = 0; i < Math.ceil(configList.length / sliceCount); i++) {
		promiseList.push(fun(configList.slice(i * sliceCount, (i + 1) * sliceCount)))
	}
	return promiseList
}

const getIsShowPrice = () => {
	let isOpenShowVisitorPrice = localStorage.getItem("isOpenShowVisitorPrice") == '1'
	return isOpenShowVisitorPrice || !!localStorage.getItem("pc_customerId")
}

/**
 * 获取吉商城接口当前版本（用作灰度切换）
 * @param {string}  key 单个配置
 */
const getSysSetting = (key) => {
	return new Promise((resolve, reject) => {
		requestUtil.jackyunPost({
			method: "sys.getsetting",
			content: key
		}, (res) => {
			let data = ""
			if (res.code == 200) {
				data = res.data[key];
			}

			resolve(data);
		})
	});
}

/**
 * 获取统一格式保质期
 */
const getFormatValidate = async (validateObj, isShowShelfLift = true) => {
	// 获取保质期配置
	let paramList = await getParam("goodsValidityDateFrom,isShowValidateBySplitType");
	return validateObj.validityDate && (paramList.goodsValidityDateFrom == "bathInfo" && paramList.isShowValidateBySplitType == "1" ? `${validateObj.productionDate ? '生产日期：' + validateObj.productionDate + "  ": ""}${validateObj.shelfLife && validateObj.shelfLiftUnitName ? (isShowShelfLift ? '保质期：' : '') + validateObj.shelfLife + validateObj.shelfLiftUnitName : ''}` : validateObj.validityDate) || "";
}

/**
 * 获取域名
 */
const getDomianName = () => {
	// 优先检测起源域名
	let originDomian = window.location.ancestorOrigins[0];
	if (originDomian) {
		return originDomian.replace("http://", "").replace("https://", "");
	}

	// 再检测直接绑定的域名
	return window.location.hostname;
}

/**
 * 返回上一页
 */
const backPage = () => {
	// // 吉商城有效域名
	// let innerDomain = ["jmall.jackyun.com", "home.es86.com", "localhost"];

	// // 获取当前域名
	// let currDomian = getDomianName();

	// // 除以上域名外属于PC域名嵌套，需要执行两次返回
	// if (!innerDomain.includes(currDomian)) {
	// 	history.back();
	// }
	history.back();
}

/**
 * 保存缓存（带吉客号信息）
 */
const setStorageForMember = (key, val) => {
	// 获取缓存key
	key = _getStorageKeyForMember(key);

	// 转换val数据格式
	if (typeof(val) == "object") {
		val = JSON.stringify(val);
	}

	// 保存缓存
	localStorage.setItem(key, val);
}

/**
 * 获取缓存（带吉客号信息）
 */
const getStorageForMember = (key) => {
	// 获取缓存key
	key = _getStorageKeyForMember(key);

	// 获取缓存
	let val = localStorage.getItem(key);

	// 转换val数据格式
	try {
		return JSON.parse(val);
	} catch (e) {
		return val;
	}
}

/**
 * 获取缓存key
 */
const _getStorageKeyForMember = (key) => {
	// 获取吉客号信息
	let memberName = localStorage.getItem("JackyunUserName");
	let subMemberName = localStorage.getItem("SubMemberName");
	// 重新拼接key并返回结果
	return (!!subMemberName && subMemberName != memberName) ? `${key}_${memberName}_${subMemberName}` : `${key}_${memberName}`;
}

/**
 * 加载中弹窗临时变量
 */
var tmpLoadingLayer;
/**
 * 显示加载中弹窗
 */
const showLoading = (_this, msg = "加载中", isAutoClose = true) => {
	// 显示加载中弹窗
	tmpLoadingLayer = _this.$loading({
		lock: true,
		text: msg,
		background: 'rgba(255, 255, 255, 0.2)'
	});

	// 一段时间后自动关闭，防止异常情况遮挡页面
	if (isAutoClose) {
		setTimeout(() => {
			closeLoading();
		}, 8 * 1000);
	}
}

/**
 * 设置规格的长宽高和重量的展示文本
 */
const getAndSetSkuInfoText = (skuInfo, context, unitInfoList, curUnitName = '') => {
	// 获取配置
	let paramList = getParamByKeysFromCache("isShowGoodsLongWidthHeight,isShowGoodsWeight,isShowGoodsVolume");

	// 基础单位信息
	let baseUnitInfo = unitInfoList.find(item => item.isBaseUnit == '1' && item.isOn == '1') || {};
	// 当前单位信息
	let curUnitInfo = unitInfoList.find(item => item.unitName == (curUnitName || baseUnitInfo.unitName) && item.isOn == '1') || {};

	// 判断是否存在长宽高有效值
	let isHaveValidLongWidthHeight = !!skuInfo.length || !!skuInfo.width || !!skuInfo.height;
	// 判断是否存在重量有效值
	let isHaveValidWeight = !!skuInfo.skuWeightVal
	// 判断是否存在体积有效值 erp取名为skuLengthVal
	let isHaveValidVolume = !!skuInfo.skuLengthVal

	//  基础单位下架的情况 补充单位数据
	if (isEmptyObjectV2(curUnitInfo)) {
		curUnitInfo.countRate = 1;
	}

	// 重量数据转换 (优先使用辅助单位上的数据)
	let skuWeightVal = curUnitInfo.unitWeight || (skuInfo.skuWeightVal * curUnitInfo.countRate).toFixed(2);
	let skuWeightUnit = curUnitInfo.unitWeightUnit || skuInfo.skuWeightUnit;
	// 体积数据转换 (优先使用辅助单位上的数据)
	let skuLengthVal = curUnitInfo.unitVolume || (skuInfo.skuLengthVal * curUnitInfo.countRate).toFixed(2);
	let skuLengthUnit = curUnitInfo.unitVolumeUnit || skuInfo.skuLengthUnit;

	// 长宽高展示文本
	let tempLongWidthHeightText = `${skuInfo.length || 0}*${skuInfo.width || 0}*${skuInfo.height || 0}cm`;
	// 重量展示文本
	let tempWeightText = `${skuWeightVal || 0}${skuWeightUnit || 'g'}`;
	// 体积展示文本
	let tempVolumeText = `${skuLengthVal || 0}${skuLengthUnit || 'cm³'}`;

	// 根据配置判断是否展示长宽高
	tempLongWidthHeightText = isHaveValidLongWidthHeight && paramList.isShowGoodsLongWidthHeight == '1' ? tempLongWidthHeightText : '';
	// 根据配置判断是否展示重量
	tempWeightText = isHaveValidWeight && paramList.isShowGoodsWeight == '1' ? tempWeightText : '';
	// 根据配置判断是否展示体积
	tempVolumeText = isHaveValidVolume && paramList.isShowGoodsVolume == '1' ? tempVolumeText : '';

	// 更新数据
	context.$set(skuInfo, 'longWidthHeightText', tempLongWidthHeightText);
	context.$set(skuInfo, 'weightText', tempWeightText);
	context.$set(skuInfo, 'volumeText', tempVolumeText);
	// label数据
	context.$set(skuInfo, 'longWidthHeightLabel', baseUnitInfo.unitName ? `长宽高（${baseUnitInfo.unitName}）：` : `长宽高：`);
	context.$set(skuInfo, 'weightLabel', curUnitInfo.unitName ? `预估重量（${curUnitInfo.unitName}）：` : `预估重量：`);
	context.$set(skuInfo, 'volumeLabel', curUnitInfo.unitName ? `预估体积（${curUnitInfo.unitName}）：` : `预估体积：`);

	// 如果辅助单位有体积数据的话 需要更新到规格数据里
	skuInfo.volume = curUnitInfo.unitVolume ? convertToCubicCentimeters(curUnitInfo.unitVolumeUnit, curUnitInfo.unitVolume) : skuInfo.volume;
}

/**
 * 将不同体积单位的值转换为立方厘米
 * @param {string} unit - 单位，可以是 'cm3', 'dm3', 'm3'
 * @param {number} value - 待转换的数值
 * @returns {number} - 转换成立方厘米后的数值
 */
function convertToCubicCentimeters(unit = 'cm3', value) {
	switch (unit.toLowerCase()) {
		case 'cm3':
			return value; // 已经是立方厘米
		case 'dm3':
			return value * 1000; // 立方分米转立方厘米
		case 'm3':
			return value * 1000000; // 立方米转立方厘米
		default:
			return '';;
	}
}

/**
 * 关闭加载中弹窗
 */
const closeLoading = () => {
	try {
		tmpLoadingLayer.close();
	} catch (e) {}
}


/**
 * 滚动到指定元素
 */
const scrollToElement = (context, targetRef) => {
	context.$nextTick(() => { // 确保 DOM 渲染完成
		context.$refs[targetRef].scrollIntoView({
			behavior: "smooth",
			block: "start"
		});
	});
}


/**
 * 检查数据是否为空
 */
const isValueEmpty = (value) => {
	if (value === null || value === undefined || value === '') {
		return true;
	}
	if (Array.isArray(value) && value.length === 0) {
		return true;
	}
	if (typeof value === 'object' && value !== null && Object.keys(value).length === 0) {
		return true;
	}
	return false;
}

/**
 * 检查对象以及对象属性是否为空
 */
const isEmptyObjectV2 = (obj) => {
	// 首先检查对象本身是否为空
	if (isValueEmpty(obj)) {
		return true;
	}

	// 检查对象的每个属性
	for (let key in obj) {
		if (obj.hasOwnProperty(key)) {
			let value = obj[key];
			if (typeof value === 'object' && value !== null) {
				if (!isEmptyObjectV2(value)) {
					return false;
				}
			} else if (!isValueEmpty(value)) {
				return false;
			}
		}
	}

	// 如果所有属性都通过了检查，则返回true
	return true;
}

/**
 * 保证小数精度的四舍五入
 */
const roundToDecimal = function(num, decimalPlaces = 2) {
	const factor = Math.pow(10, decimalPlaces);
	return Number.isNaN(num) ? 0 : Math.round(num * factor) / factor;
}

/**
 * 获取单位购买量不符合的商品
 */
const getUnitCountLimitList = function(orderGoodsList) {
	return orderGoodsList.filter(item => {
		let matchedUnitInfo = item.unitInfoList.filter(unit => unit.countRate > item.unitCountRate && unit.isOn == '1')
			.sort((a, b) => a.countRate - b.countRate)[0] || {};

		// 单位购买量超出数量
		item.unitOverCount = getUnitOverCount(item, matchedUnitInfo);
		item.unitOverCount = Math.floor(item.unitOverCount)
		item.matchedOverCountUnitInfo = matchedUnitInfo;

		return item.unitOverCount > 0
	})
}

/**
 * 获取单位购买量 转化后的购物车
 */
const getTempCartListForUnitCountLimit = function(tempShopCartList) {
	let needAddCart = []

	tempShopCartList.forEach(item => {
		item.cartId = '';
		item.cartType = '';

		if (item.unitOverCount < 0) {
			return
		}

		// 转化后的单位数量
		let unitCountObj = getNeedUnitCountInfo(item.goodsCount, item.unitCountRate, item.matchedOverCountUnitInfo.countRate)

		// 补充新增cart
		needAddCart.push(Object.assign(JSON.parse(JSON.stringify(item)), {
			unit: item.matchedOverCountUnitInfo.unitName,
			unitName: item.matchedOverCountUnitInfo.unitName,
			unitCountRate: item.matchedOverCountUnitInfo.countRate,
			goodsCount: unitCountObj.matchedUnitNeedCount,
		}))

		// 修改当前cart数量  换算成基础单位后的剩余可购买量 / 购买单位的兑换比例
		item.goodsCount = unitCountObj.curUnitNeedCount
	})

	return mergeAndSum([...tempShopCartList, ...needAddCart].filter(item => item.goodsCount > 0), ['goodsId', 'specId', 'unitName', 'actId', 'actType'], 'goodsCount')
}

/**
 * 获取需要的单位购买量
 * @param t 当前单位的购买量
 * @param a 当前单位比例
 * @param b 匹配单位比例
 */
function getNeedUnitCountInfo(t, a, b) {
	const target = roundToDecimal(a * t, 2);
	const maxZ = Math.floor(target / b);

	for (let z = maxZ; z >= 0; z--) {
		const remainder = roundToDecimal(target - b * z, 2);
		if (remainder >= 0 && remainder % a === 0) {
			const y = remainder / a;
			return {
				curUnitNeedCount: y,
				matchedUnitNeedCount: z
			}; // 找到最优解（z 最大）
		}
	}

	// 理论上不会走到这里，因为一定有解（z=0, y=t）
	return {
		curUnitNeedCount: t,
		matchedUnitNeedCount: 0
	};
}

/**
 * 计算单位超出量
 */
function getUnitOverCount(curUnitInfo, matchedUnitInfo) {
	// 如果不存在 匹配的辅助单位 或者 
	if (isEmptyObjectV2(matchedUnitInfo) || isRepeatingDecimal(matchedUnitInfo.countRate, curUnitInfo.unitCountRate)) {
		return -1
	}

	return curUnitInfo.goodsCount - ((matchedUnitInfo.countRate % curUnitInfo.unitCountRate == 0 ? matchedUnitInfo.countRate / curUnitInfo.unitCountRate : matchedUnitInfo.countRate / gcd(matchedUnitInfo.countRate, curUnitInfo.unitCountRate)) - 1);
}

/**
 * 求最大公约数（GCD）
 */
function gcd(a, b) {
	a = Math.abs(a);
	b = Math.abs(b);
	while (b !== 0) {
		[a, b] = [b, a % b];
	}
	return a;
}

/**
 * 判断分母是否只含质因数 2 和 5
 */
function hasOnly2And5(n) {
	n = Math.abs(n);
	while (n % 2 === 0) n /= 2;
	while (n % 5 === 0) n /= 5;
	return n === 1;
}

/**
 *判断 a / b 是否为无限循环小数
 */
function isRepeatingDecimal(a, b) {
	if (b === 0) return true;
	if (Number.isInteger(a) && Number.isInteger(b)) return false;

	// 化为最简分数
	const g = gcd(a, b);
	const q = b / g; // 最简分母

	// 如果最简分母只含 2 和 5，则是有限小数；否则是无限循环小数
	return !hasOnly2And5(q);
}

/**
 * 根据指定字段去重，并将指定字段的值相加
 * @param {Array} arr - 原数组
 * @param {Array} keys - 用于判断重复的字段数组，如 ['a', 'b', 'c']
 * @param {String} sumKey - 需要累加的字段，如 'd'
 * @returns {Array} 处理后的新数组
 */
function mergeAndSum(arr, keys, sumKey) {
	const map = new Map();

	for (const item of arr) {
		// 生成基于 keys 的唯一键，如 "a|b|c"
		const key = keys.map(k => item[k]).join('|');

		if (map.has(key)) {
			// 已存在，累加 sumKey
			map.get(key)[sumKey] += item[sumKey];
		} else {
			// 首次出现，深拷贝对象（避免引用）
			map.set(key, {
				...item
			});
		}
	}

	return Array.from(map.values());
}

export default {
	setImg,
	set400Img,
	set800Img,
	amountFixed,
	formatTime,
	sortBy,
	regTel,
	checkTel,
	getCustomerId,
	formatNumber,
	htmlEncode,
	convertTime,
	htmlDecode,
	htmlDecodeForMiddleRichText,
	stringToDate,
	debounce,
	groupBy,
	sumArr,
	underlineToHump,
	isNullOrEmpty,
	floatKeepDigit,
	distinctArr,
	getAllNeedInfoByConfigList,
	getIsShowPrice,
	getSysSetting,
	getFormatValidate,
	filterTrailingZeros,
	ueStrDecode,
	getDefaultImg,
	backPage,
	setStorageForMember,
	getStorageForMember,
	showLoading,
	closeLoading,
	scrollToElement,
	isEmptyObjectV2,
	getAndSetSkuInfoText,
	throttleWithAlert,
	throttle,
	roundToDecimal,
	getUnitCountLimitList,
	getTempCartListForUnitCountLimit,
	mergeAndSum
}